import React, { useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import Close from '@elem/SVGIcon/125wRigidSolarPanel/Close';
import EFPicture from '@elem/compCommon/EFPicture';
import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA1');
    const [activeContent, setActiveContent] = useState(0);

    const tipsData = [
        {
            title: t('icon_title_1'),
            content: t('icon_desc_1'),
        },
        {
            title: t('icon_title_2'),
            content: t('icon_desc_2'),
        },
        {
            title: t('icon_title_3'),
            content: t('icon_desc_3'),
        },
        // {
        //     title: t('icon_title_4'),
        //     content: t('icon_desc_4'),
        // },
    ];

    const handleBtnClick = (index: number) => {
        if (!!activeContent && activeContent === index + 1) {
            setActiveContent(0);
            return;
        }
        setActiveContent(index + 1);
    };

    return (
        <section className={`${styles.comp} temp-section-1`} id="section-1">
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`temp-section-1-imgs-box`}>
                <div className="temp-section-1-img">
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1744099258654/charger_section1.jpg"
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1744099258855/charger_section1_h5.png"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1744099258855/charger_section1_h5.png"
                    />
                </div>

                <div className="imgs-box-bottom">
                    {tipsData?.map((item: any, index: number) => (
                        <div
                            key={index}
                            className={`actions-box actions-box-${index + 1} ${activeContent === index + 1 ? 'actions-box-active' : ''}`}
                            onClick={() => handleBtnClick(index)}
                        >
                            {activeContent === index + 1 && (
                                <div className={`tip-hidden-content`}>
                                    {!!item?.title && <p className="tip-hidden-title">{item?.title}</p>}
                                    <p className="tip-hidden-content-item">{item?.content}</p>
                                </div>
                            )}
                            <div className="tip-visible-content">
                                <div className={`close-icon ${activeContent === index + 1 ? 'close-icon-active' : ''}`}>
                                    <Close />
                                </div>
                                {!!item?.title && <p className="tip-title">{item?.title}</p>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <EcoSpace className="section-1-bottom-space" />
        </section>
    );
}
